import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const clearbit = defineConnector({
  identifier: "clearbit",
  name: "Clearbit",
  tagLine: "Business intelligence",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://.*\\.clearbit\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [Clearbit](https://clearbit.com/), go to **API** in your dashboard to find your API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://company.clearbit.com/v2/companies/find?domain=clearbit.com",
  },
});
